module.exports = __webpack_public_path__ + "img/private_event_plate2.5f775f9a.jpg";